var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "matrix(1.75937,0,0,1.90981,-3464.16,-2876.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "white",
    d: "M2019.93,1708.82L1989.64,1708.99C1989.63,1708.39 1983.97,1646.2 1997.75,1610.72C2005.8,1589.98 2020.48,1576.78 2041.59,1576.86C2056.39,1576.92 2066.43,1581.16 2073.6,1587.37C2083.14,1595.64 2087.56,1608.51 2089.27,1623.13C2090.52,1633.86 2090.48,1645.62 2092.49,1655.79C2093.59,1661.33 2094.81,1666.48 2099.32,1669.32C2102.25,1671.16 2106.33,1671.73 2111.76,1671.57C2115.12,1671.47 2117.78,1670.98 2119.77,1669.73C2122.91,1667.76 2124.07,1664.32 2125.08,1660.56C2127.05,1653.23 2127.34,1644.56 2127.8,1635.91C2129.52,1604.35 2135.91,1575.34 2176.03,1574.54C2207.43,1573.91 2223.94,1594.64 2230.15,1622.87C2237.32,1655.49 2231.33,1701.13 2231.33,1708.99L2201.03,1708.99C2201.03,1701.63 2207.15,1658.74 2200.44,1628.22C2197.38,1614.3 2192.19,1601.64 2176.7,1601.95C2172.11,1602.05 2168.64,1602.77 2166.18,1604.59C2161.86,1607.81 2160.72,1613.25 2159.72,1619.13C2157.96,1629.43 2158.12,1641.2 2157.07,1651.94C2155.37,1669.37 2149.83,1684.22 2137.05,1692.25C2130.94,1696.1 2123.09,1698.67 2112.75,1698.98C2098.54,1699.4 2088.45,1696.17 2081.02,1691.18C2073.78,1686.31 2068.84,1679.55 2065.71,1671.41C2062.18,1662.21 2061.08,1650.96 2060.28,1639.62C2059.68,1631.03 2059.28,1622.4 2057.08,1615.13C2056.09,1611.87 2054.88,1608.9 2052.32,1606.9C2049.86,1604.98 2046.28,1604.3 2041.46,1604.28C2037,1604.26 2033.95,1606.76 2031.46,1610.1C2026.99,1616.09 2024.3,1624.43 2022.41,1633.45C2015.7,1665.39 2019.92,1708.34 2019.93,1708.82Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.f184396c8b55e7c7aa77ead5bbaa4b25.svg";
export { ForwardRef as ReactComponent };